import {
  login,
  logout,
  getUserInfo,
  getMessage,
  getContentByMsgId,
  hasRead,
  removeReaded,
  restoreTrash,
  getUnreadCount,
  UpdPWD,
  UpdPWDWage,
  SetMotto,
  SetAvatar,
  register,
  Forgot,
  getregion,
  getsms,
  GetEmall,
  savebaseinfo,
  changeaccount,
  real_name_auth,
  enterprise,
  enterprise_audit_count_down,
  realname_audit_count_downr,
  index_overview,
  service_overview,
  user_overview,
  product_overview
} from "@/api/user";
import { getdownloadtoken } from "@/api/jingxiaoshang";
import { setToken, getToken } from "@/libs/util";
import config from "@/config/index";
import { JSEncrypt } from "jsencrypt";
import Cookies from "js-cookie";
export default {
  state: {
    userName: "",
    userId: "",
    avatorImgPath: "",
    token: getToken(),
    access: "",
    hasGetInfo: false,
    unreadCount: 0,
    messageUnreadList: [],
    messageReadedList: [],
    messageTrashList: [],
    messageContentStore: {},
    userInfo: {},
    oldState: false, //call status
    companyCode: null,
    websocketData: null
  },
  mutations: {
    setWebsocketData(state, data) {
      state.websocketData = data;
    },
    setUersInfo(state, data) {
      state.userInfo = data;
    },
    setAvator(state, avatorPath) {
      state.avatorImgPath = avatorPath;
    },
    setUserId(state, id) {
      state.userId = id;
    },
    setUserName(state, name) {
      state.userName = name;
    },
    setAccess(state, access) {
      state.access = access;
    },
    setToken(state, token) {
      state.token = token;
      setToken(token);
    },
    setHasGetInfo(state, status) {
      state.hasGetInfo = status;
    },
    setMessageCount(state, count) {
      state.unreadCount = count;
    },
    setMessageUnreadList(state, list) {
      state.messageUnreadList = list;
    },
    setMessageReadedList(state, list) {
      state.messageReadedList = list;
    },
    setMessageTrashList(state, list) {
      state.messageTrashList = list;
    },
    updateMessageContentStore(state, { msg_id, content }) {
      state.messageContentStore[msg_id] = content;
    },
    moveMsg(state, { from, to, msg_id }) {
      const index = state[from].findIndex(_ => _.msg_id === msg_id);
      const msgItem = state[from].splice(index, 1)[0];
      msgItem.loading = false;
      state[to].unshift(msgItem);
    },
    /**
     * 改变call status
     * @param state
     * @param flag
     */
    changeOlaState(state, flag) {
      state.oldState = flag;
    },
    setCompanyCode(state, code) {
      state.companyCode = code;
    }
  },
  getters: {
    messageUnreadCount: state => state.messageUnreadList.length,
    messageReadedCount: state => state.messageReadedList.length,
    messageTrashCount: state => state.messageTrashList.length
  },
  actions: {
    // 登录
    handleLogin({ commit }, params) {
      let param = {};
      param.admin_password = params.password;
      param.admin_name = params.userName;
      param.admin_lang_type = params.admin_lang_type;
      return new Promise((resolve, reject) => {
        login(param)
          .then(res => {
            if (res.result === 0) {
              commit("setToken", res.body.token);
            } else {
              commit("setToken", "");
            }
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 退出登录
    handleLogOut({ state, commit }, params) {
      return new Promise((resolve, reject) => {
        // debugger
        logout(params)
          .then(res => {
            //  debugger
            if (res.result === 0) {
              // 如果你的退出登录无需请求接口，则可以直接使用下面三行代码而无需使用logout调用接口
              commit("setToken", "");
              commit("setAccess", []);
              commit("setUersInfo", {});
              commit("setHasGetInfo", false);
              Cookies.remove("token");
              Cookies.set("confirm_password", "0", 0);
              //Cookies.remove('confirm_password');
              localStorage.clear();
              sessionStorage.clear();
              resolve(res);
            } else {
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    //注册商家账号
    handleRegister({ commit }, params) {
      return new Promise((resolve, reject) => {
        register(params)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    //找回密码
    handleForgot({ commit }, params) {
      return new Promise((resolve, reject) => {
        Forgot(params)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    //获取短信验证码
    handleGetsms({ commit }, params) {
      return new Promise((resolve, reject) => {
        getsms(params)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    //获取邮箱验证码
    handleGetEmall({ commit }, params) {
      return new Promise((resolve, reject) => {
        GetEmall(params)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    //保存基本信息
    handleSavebaseinfo({ commit }, params) {
      return new Promise((resolve, reject) => {
        savebaseinfo(params)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    //保存基本信息
    handlegetdownloadtoken({ commit }, params) {
      return new Promise((resolve, reject) => {
        getdownloadtoken(params)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },

    // 获取用户相关信息
    getUserInfo({ state, commit }) {
      return new Promise((resolve, reject) => {
        try {
          getUserInfo()
            .then(res => {
              if (res.result === 0) {
                const data = res.body;
                commit("setUersInfo", data);
                commit("setAvator", data.avatar);
                commit("setUserName", data.admin_name);
                commit("setHasGetInfo", true);
                commit("setCompanyCode", data.company_code);
                resolve(res);
              } else {
                resolve(false);
              }
            })
            .catch(err => {
              reject(err);
            });
        } catch (error) {
          reject(error);
        }
      });
    },

    /**
     * 获取地区省市县
     */
    handleGetregion({ commit }, params) {
      return new Promise((resolve, reject) => {
        getregion(params)
          .then(res => {
            if (res.result === 0) {
              resolve(res);
            } else {
              resolve(res);
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 此方法用来获取未读消息条数，接口只返回数值，不返回消息列表
    getUnreadMessageCount({ state, commit }) {
      getUnreadCount().then(res => {
        const { data } = res;
        commit("setMessageCount", data);
      });
    },
    // 获取消息列表，其中包含未读、已读、回收站三个列表
    getMessageList({ state, commit }) {
      return new Promise((resolve, reject) => {
        getMessage()
          .then(res => {
            const { unread, readed, trash } = res.data;
            commit(
              "setMessageUnreadList",
              unread.sort(
                (a, b) => new Date(b.create_time) - new Date(a.create_time)
              )
            );
            commit(
              "setMessageReadedList",
              readed
                .map(_ => {
                  _.loading = false;
                  return _;
                })
                .sort(
                  (a, b) => new Date(b.create_time) - new Date(a.create_time)
                )
            );
            commit(
              "setMessageTrashList",
              trash
                .map(_ => {
                  _.loading = false;
                  return _;
                })
                .sort(
                  (a, b) => new Date(b.create_time) - new Date(a.create_time)
                )
            );
            resolve();
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 根据当前点击的消息的id获取内容
    getContentByMsgId({ state, commit }, { msg_id }) {
      return new Promise((resolve, reject) => {
        let contentItem = state.messageContentStore[msg_id];
        if (contentItem) {
          resolve(contentItem);
        } else {
          getContentByMsgId(msg_id).then(res => {
            const content = res.data;
            commit("updateMessageContentStore", { msg_id, content });
            resolve(content);
          });
        }
      });
    },
    // 把一个未读消息标记为已读
    hasRead({ state, commit }, { msg_id }) {
      return new Promise((resolve, reject) => {
        hasRead(msg_id)
          .then(() => {
            commit("moveMsg", {
              from: "messageUnreadList",
              to: "messageReadedList",
              msg_id
            });
            commit("setMessageCount", state.unreadCount - 1);
            resolve();
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 删除一个已读消息到回收站
    removeReaded({ commit }, { msg_id }) {
      return new Promise((resolve, reject) => {
        removeReaded(msg_id)
          .then(() => {
            commit("moveMsg", {
              from: "messageReadedList",
              to: "messageTrashList",
              msg_id
            });
            resolve();
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 还原一个已删除消息到已读消息
    restoreTrash({ commit }, { msg_id }) {
      return new Promise((resolve, reject) => {
        restoreTrash(msg_id)
          .then(() => {
            resolve();
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    /**
     * 检查客户号码是否属于当前账号
     * @param commit
     * @param params
     * @returns {Promise<any>}
     */
    handleCustomerIsBelongMe({ commit }, params) {
      return new Promise((resolve, reject) => {
        CustomerIsBelongMe(params)
          .then(res => {
            if (res.result === 0) {
              resolve(res);
            } else {
              resolve(res);
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    /**
     * 添加客户基本信息
     * @param commit
     * @param params
     * @returns {Promise<any>}
     */
    handleAddCustomer({ commit }, params) {
      return new Promise((resolve, reject) => {
        AddCustomer(params)
          .then(res => {
            if (res.result === 0) {
              resolve(res);
            } else {
              resolve(res);
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },

    /**
     * 修改密码
     * @param commit
     * @param params
     * @returns {Promise<any>}
     */
    handleUpdPWD({ commit }, params) {
      let key = config.jsencryptKey;
      let encrypt = new JSEncrypt();
      encrypt.setPublicKey(key);
      params.oldPwd = encrypt.encrypt(params.oldPwd);
      params.newPwd = encrypt.encrypt(params.newPwd);
      return new Promise((resolve, reject) => {
        UpdPWD(params)
          .then(res => {
            if (res.result === 0) {
              resolve(res);
            } else {
              resolve(res);
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    /**
     * 修改查看工资密码
     * @param commit
     * @param params
     * @returns {Promise<any>}
     */
    handleUpdPWDWage({ commit }, param) {
      let key = config.jsencryptKey;
      let encrypt = new JSEncrypt();
      encrypt.setPublicKey(key);
      let params = {};
      Object.assign(params, param);
      params.oldPayrollPwd = encrypt.encrypt(params.oldPayrollPwd);
      params.newPayrollPwd = encrypt.encrypt(params.newPayrollPwd);
      return new Promise((resolve, reject) => {
        UpdPWDWage(params)
          .then(res => {
            if (res.result === 0) {
              resolve(res);
            } else {
              resolve(res);
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    /**
     * 设置登录人座右铭
     * @param commit
     * @param params
     * @returns {Promise<any>}
     */
    handleSetMotto({ commit }, params) {
      return new Promise((resolve, reject) => {
        SetMotto(params)
          .then(res => {
            if (res.result === 0) {
              resolve(res);
            } else {
              resolve(res);
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    /**
     * 设置头像
     * @param commit
     * @param params
     * @returns {Promise<any>}
     */
    handleSetAvatar({ commit }, params) {
      return new Promise((resolve, reject) => {
        SetAvatar(params)
          .then(res => {
            if (res.result === 0) {
              resolve(res);
            } else {
              resolve(res);
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    /**
     * getemailcode 变更账号
     */
    handleChangeaccount({ commit }, params) {
      return new Promise((resolve, reject) => {
        changeaccount(params)
          .then(res => {
            if (res.result === 0) {
              resolve(res);
            } else {
              resolve(res);
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    /**
     * 19.实名认证 enterprise
     * @param commit
     * @param params
     * @returns {Promise<any>}
     */
    handlereal_name_auth({ commit }, params) {
      return new Promise((resolve, reject) => {
        real_name_auth(params)
          .then(res => {
            if (res.result === 0) {
              resolve(res);
            } else {
              resolve(res);
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    /**
     * enterprise //20.企业认证
     */
    handleEnterprise({ commit }, params) {
      return new Promise((resolve, reject) => {
        enterprise(params)
          .then(res => {
            if (res.result === 0) {
              resolve(res);
            } else {
              resolve(res);
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    /**
     * 企业认证倒计时
     * @param commit
     * @param params
     * @returns {Promise<any>}
     */
    handleenterprise_audit_count_down({ commit }, params) {
      return new Promise((resolve, reject) => {
        enterprise_audit_count_down(params)
          .then(res => {
            if (res.result === 0) {
              resolve(res);
            } else {
              resolve(res);
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    /**
     * 实名认证倒计时
     * @param commit
     * @param params
     * @returns {Promise<any>}
     */
    handlerealname_audit_count_downr({ commit }, params) {
      return new Promise((resolve, reject) => {
        realname_audit_count_downr(params)
          .then(res => {
            if (res.result === 0) {
              resolve(res);
            } else {
              resolve(res);
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    /**
     * 首页总览统计数据
     * @param commit
     * @param params
     * @returns {Promise<any>}
     */
    handleindex_overview({ commit }, params) {
      return new Promise((resolve, reject) => {
        index_overview(params)
          .then(res => {
            if (res.result === 0) {
              resolve(res);
            } else {
              resolve(res);
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    /**
     * 产品统计数据
     * @param commit
     * @param params
     * @returns {Promise<any>}
     */
    handleproduct_overview({ commit }, params) {
      return new Promise((resolve, reject) => {
        product_overview(params)
          .then(res => {
            if (res.result === 0) {
              resolve(res);
            } else {
              resolve(res);
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    /**
     * 用户统计数据
     * @param commit
     * @param params
     * @returns {Promise<any>}
     */
    handleuser_overview({ commit }, params) {
      return new Promise((resolve, reject) => {
        user_overview(params)
          .then(res => {
            if (res.result === 0) {
              resolve(res);
            } else {
              resolve(res);
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    /**
     * 服务统计数据
     * @param commit
     * @param params
     * @returns {Promise<any>}
     */
    handleservice_overview({ commit }, params) {
      return new Promise((resolve, reject) => {
        service_overview(params)
          .then(res => {
            if (res.result === 0) {
              resolve(res);
            } else {
              resolve(res);
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  }
};
